module.exports = __webpack_public_path__ + "assets/img/Infographics2.07121d2f.png";